import script from "./GamesList.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesList.vue?vue&type=script&setup=true&lang=js"

import "./GamesList.vue?vue&type=style&index=0&id=6a510f8e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96/0/frontvue/main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a510f8e"]])

export default __exports__